let MyDirectusStorage;
MyDirectusStorage = require("./MyDirectusStorageWeb").MyDirectusStorageWeb;

export { MyDirectusStorage }
